import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";

const CreateCourse = () => {
 const [title, setTitle] = useState("");
 const [description, setDescription] = useState("");
 const { createCourse, checkAuth } = useContext(UserContext);

 useEffect(() => {
  try {
   checkAuth();
  } catch (error) {
   console.log(error);
  }
 }, []);

 const handleSubmit = (e) => {
  e.preventDefault();
  try {
   createCourse({ title, description });
   setTitle("");
   setDescription("");
  } catch (error) {
   console.log("error from create course");
  }
 };
 return (
  <div className="create-course">
   <form onSubmit={handleSubmit}>
    <input
     type="text"
     value={title}
     onChange={(e) => setTitle(e.target.value)}
     placeholder="course title"
     required
    />
    <input
     type="text"
     value={description}
     onChange={(e) => setDescription(e.target.value)}
     placeholder="course description"
     required
    />
    <button>Create</button>
   </form>
  </div>
 );
};

export default CreateCourse;
